import React, { useState } from 'react';
import { useFetch, Items } from '@thinkwell/react.common'

const SectionsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const SectionsProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))

  const [fetchSectionsState, fetchSections] = useFetch({onSuccess: setItems})

  const value = [items, fetchSections, fetchSectionsState, upsertItem, getItem, deleteItem]
  props.onValue && props.onValue(value)

  return (
    <SectionsContext.Provider value={value}>
      {props.children}
    </SectionsContext.Provider>
  );
};

export { SectionsContext, SectionsProvider}
